export default __webpack_public_path__ + "static/media/content-background-1.a2b15734.svg";